module.exports = __webpack_public_path__ + "img/acmedlogonew.4265a531.png";